// ------------------------------------
// Constants
// ------------------------------------
export const initialState: State.LandingPagesContent = {
  landingPage: null,
  landingPageFetched: false,
  skipLandingPageFrontloadRequest: false,
};
